module.exports = __webpack_public_path__ + "static/media/ding.0ce54b5.aac";


//////////////////
// WEBPACK FOOTER
// ./src/pages/suspect/ding.aac
// module id = BDt9
// module chunks = 1